export default "__VITE_ASSET__DKndS_$j__"